import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBatteryEmpty,
  faCertificate,
  faCheck,
  faDesktop,
  faDownload,
  faEraser,
  faEye,
  faEyeSlash,
  faMobile,
  faVrCardboard,
  faWifi,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faEraser,
  faDesktop,
  faBatteryEmpty,
  faMobile,
  faVrCardboard,
  faWifi,
  faCertificate,
  faCheck,
  faEye,
  faEyeSlash,
  faDownload,
);
